let state = { open: false, options: {}, resolve: null };
const listeners = new Set();
const emit = () => listeners.forEach((listener) => listener());
export const subscribeConfirmDialog = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};
export const getConfirmDialogSnapshot = () => state;
export const confirmDialog = (options) => new Promise((resolve) => {
    state.resolve?.(false);
    state = { open: true, options, resolve };
    emit();
});
/** Резолвит промис сразу — вызывающий код (санка/компонент) не ждёт анимацию. */
export const resolveConfirmDialog = (result) => {
    state.resolve?.(result);
    state = { ...state, open: false, resolve: null };
    emit();
};
/** Вызывается ТОЛЬКО когда transition закрытия физически завершился (onExited). */
export const clearConfirmDialogOptions = () => {
    state = { ...state, options: {} };
    emit();
};
